import React from 'react';
import { Palette, Users, Truck } from 'lucide-react';
import { howItWorksContent } from '@/hooks/useContent';

// Icon mapping
const iconMap = {
  Palette: Palette,
  Users: Users,
  Truck: Truck,
};

const HowItWorks = () => {
  const content = howItWorksContent;

  return (
    <section 
      className="py-24" 
      style={{ backgroundColor: content.background?.color || '#F5EFE3' }}
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="section-title text-4xl md:text-5xl font-bold mb-4" data-testid="how-it-works-title">
            {content.title}
          </h2>
          <p className="section-subtitle text-xl max-w-2xl mx-auto" data-testid="how-it-works-subtitle">
            {content.subtitle}
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {content.steps?.map((step, index) => {
            const IconComponent = iconMap[step.icon] || Palette;
            return (
              <div 
                key={index}
                className="relative bg-white rounded-lg p-8 shadow-sm hover:shadow-xl transition-all duration-300"
                data-testid={`step-${index + 1}`}
              >
                {/* Step Number */}
                <div 
                  className="absolute -top-6 -left-6 text-6xl font-bold opacity-10"
                  style={{ color: '#8B7355' }}
                >
                  {step.number}
                </div>

                {/* Icon */}
                <div 
                  className="mb-6 inline-block p-4 rounded-lg"
                  style={{ 
                    backgroundColor: '#F5EFE3',
                    color: '#8B7355'
                  }}
                >
                  <IconComponent size={40} />
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold mb-4" style={{ color: '#1e1919' }}>
                  {step.title}
                </h3>
                <p className="text-base leading-relaxed" style={{ color: '#736c64' }}>
                  {step.description}
                </p>

                {/* Connector Line (not on last item) */}
                {index < content.steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-6 lg:-right-12 w-6 lg:w-12 h-0.5 bg-gradient-to-r from-[#8B7355] to-transparent"></div>
                )}
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="cta-button px-8 py-4 rounded-md font-semibold text-lg transition-all duration-300"
            data-testid="how-it-works-cta"
          >
            {content.cta_text}
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
